import { render, staticRenderFns } from "./default.vue?vue&type=template&id=944b2fe2&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Footer: require('/app/components/Footer.vue').default,LayoutWrap: require('/app/components/LayoutWrap.vue').default})
